export default "__VITE_PUBLIC_ASSET__5829865f__"